(() => {
  const initialize = (scope = document) => {
    scope.querySelectorAll('[data-customer-love]').forEach((section) => {
      if (section.dataset.loveReady) return;
      section.dataset.loveReady = 'true';
      const previous = section.querySelector('[data-love-prev]');
      const next = section.querySelector('[data-love-next]');
      if (section.dataset.archive === 'true') {
        const cards = [...section.querySelectorAll('[data-love-rating]')];
        const filter = section.querySelector('[data-love-filter]');
        const status = section.querySelector('[data-love-status]');
        let page = 0;
        const render = (moveFocus = false) => {
          const matching = cards.filter((card) => filter.value === 'all' || card.dataset.loveRating === filter.value);
          const pages = Math.ceil(matching.length / 24);
          page = Math.max(0, Math.min(page, pages - 1));
          const visible = matching.slice(page * 24, page * 24 + 24);
          const shown = new Set(visible);
          cards.forEach((card) => { card.hidden = !shown.has(card); });
          previous.disabled = page === 0;
          next.disabled = page + 1 >= pages;
          status.textContent = pages ? status.dataset.page.replace('__CURRENT__', String(page + 1)).replace('__TOTAL__', String(pages)) : status.dataset.empty;
          if (moveFocus && visible[0]) visible[0].focus({ preventScroll: false });
        };
        filter.addEventListener('change', () => { page = 0; render(); });
        previous.addEventListener('click', () => { page -= 1; render(true); });
        next.addEventListener('click', () => { page += 1; render(true); });
        render();
        section.querySelectorAll('[data-love-controls]').forEach((controls) => { controls.hidden = false; });
      } else {
        const track = section.querySelector('.dl-love__track');
        const update = () => {
          previous.disabled = track.scrollLeft <= 4;
          next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
        };
        const scroll = (direction) => {
          const card = track.querySelector('.dl-love__card');
          track.scrollBy({ left: direction * (card.getBoundingClientRect().width + 20), behavior: 'auto' });
        };
        previous.addEventListener('click', () => scroll(-1));
        next.addEventListener('click', () => scroll(1));
        track.addEventListener('scroll', update, { passive: true });
        new ResizeObserver(update).observe(track);
        previous.hidden = false;
        next.hidden = false;
        update();
      }
    });
  };
  initialize();
  if (!window.dlLoveEditorListener) {
    window.dlLoveEditorListener = true;
    document.addEventListener('shopify:section:load', () => initialize());
  }
})();
